import ConsumerPage from './consumer.container';

export default ConsumerPage;